import { render, staticRenderFns } from "./PullRevenueIntro.vue?vue&type=template&id=795d0436&scoped=true&"
import script from "./PullRevenueIntro.vue?vue&type=script&lang=js&"
export * from "./PullRevenueIntro.vue?vue&type=script&lang=js&"
import style0 from "./PullRevenueIntro.vue?vue&type=style&index=0&id=795d0436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795d0436",
  null
  
)

export default component.exports